import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ImageLabel } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { MainWebShop, ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { isNullOrUndefined } from '@as-react/common-utils';
import { CaretRightIcon } from '@yonderland/andes-icons';
import { Box, Breakpoint, Icon, Stack, TextAlpha } from '@yonderland/andes-react';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import MiniPDPMultiContainer from '../../../containers/MiniPDPMultiContainer';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { makeGetPreviewInformation, makeGetProductDefaults, makeGetLinkedProducts, makeGetMainWebshopId, } from '../../../redux/product/selectors/ProductSelector';
import { getImageSourceSetByProductCode } from '../../../util/ImageUtil';
const MAX_PRODUCTS = 4;
export const ProductDetailShopTheLook = ({ defaultTitle, flyoutTitle, linkLabel }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { mainWebShop, productImageConfig } = useAemConfig();
    const [isOpenMiniPDP, setIsOpenMiniPDP] = useState(false);
    const { images } = useSelector(makeGetPreviewInformation());
    const { productCode } = useSelector(makeGetProductDefaults());
    const linkedProducts = useSelector(makeGetLinkedProducts());
    const mainWebshopId = useSelector(makeGetMainWebshopId());
    const dispatch = useDispatch();
    const defaultPicture = !isNullOrUndefined(images[1]) ? images[1].picture : images[0].picture;
    const openMiniPDP = () => {
        dispatch(analyticsActions.shopTheLookOpened(defaultPicture));
        setIsOpenMiniPDP(true);
    };
    const onMiniPDPClose = () => {
        setIsOpenMiniPDP(false);
    };
    const getImage = () => getImageSourceSetByProductCode(productCode, defaultPicture, productImageConfig)[ProductImageSizesPortraitEnum.detail];
    const updatedProducts = useMemo(() => {
        let shopTheLookProducts = [];
        if (linkedProducts.length <= MAX_PRODUCTS) {
            shopTheLookProducts = linkedProducts;
        }
        else {
            const productsWithAvailability = linkedProducts.map(product => (Object.assign(Object.assign({}, product), { isLookColorAvailable: product.colours.find(colour => colour.colourId === product.colourId).availability > 0 })));
            const availableProducts = productsWithAvailability.filter(product => product.isLookColorAvailable);
            const availableProductsAmount = availableProducts.length;
            if (availableProductsAmount >= MAX_PRODUCTS) {
                shopTheLookProducts = availableProducts.slice(0, MAX_PRODUCTS);
            }
            else {
                const maxOOSProductsToShow = MAX_PRODUCTS - availableProductsAmount;
                let addedOOSProductsAmount = 0;
                shopTheLookProducts = productsWithAvailability.reduce((products, product) => {
                    if (products.length < MAX_PRODUCTS) {
                        if (product.isLookColorAvailable) {
                            products.push(product);
                        }
                        else if (maxOOSProductsToShow !== addedOOSProductsAmount) {
                            addedOOSProductsAmount++;
                            products.push(product);
                        }
                    }
                    return products;
                }, []);
            }
        }
        return shopTheLookProducts.map(product => (Object.assign(Object.assign({}, product), { colours: product.colours.sort(color => (color.colourId === product.colourId ? -1 : 1)) })));
    }, [linkedProducts]);
    const getTitleTranslation = () => mainWebShop === MainWebShop.JUTTU ? t('product.look.pdp.title.specific') : t('product.look.pdp.title');
    return (_jsxs(_Fragment, { children: [_jsx(Breakpoint, { until: "sm", children: _jsxs(Box, { paddingBlockStart: "8", children: [_jsx(TextAlpha, { as: "h2", variant: "subheadingS", children: defaultTitle || getTitleTranslation() }), _jsx(Box, { marginInline: { base: '-4', md: '0' }, paddingBlockStart: "3", children: _jsx(ImageLabel, { image: { src: getImage(), lazy: true }, label: _jsx(Box, { paddingInlineStart: "1", children: _jsxs(Stack, { gap: "3", children: [_jsx(TextAlpha, { as: "span", variant: "bodyS", color: "current", children: linkLabel || getTitleTranslation() }), _jsx(Icon, { source: CaretRightIcon, size: "sm" })] }) }), onClick: openMiniPDP }) })] }) }), _jsx(MiniPDPMultiContainer, { isOpen: isOpenMiniPDP, onClose: onMiniPDPClose, productsInfo: updatedProducts, popoverTitle: flyoutTitle, title: defaultTitle, mainWebshopId: mainWebshopId, isPDP: true })] }));
};
